// The Phone app's people. Everyone here is made up (characters and placeholders, in the spirit of
// the locked notes), with numbers from the 555-01xx range set aside for fiction; only My Card is
// real. `last` is the name contacts sort by and shows in bold, as on iOS.
import { resume } from "./resume";

const contact = (label) => resume.contacts.find((c) => c.label === label);

export const MY_CARD = {
  id: "me",
  first: "Sylvester",
  last: "Asare Sarpong",
  photo: true,
  fields: [
    { label: "email", value: contact("Email").text, href: contact("Email").href },
    { label: "website", value: contact("Website").text, href: contact("Website").href },
    { label: "LinkedIn", value: contact("LinkedIn").text, href: contact("LinkedIn").href },
  ],
};

export const CONTACTS = [
  { id: "area51", first: "Area 51 Front Desk", phone: "+1 (775) 555-0151", note: "It's called Site 15 now" },
  { id: "chihiro", first: "Chihiro", last: "Ogino", phone: "+81 3-555-0108" },
  { id: "don", first: "Don", last: "Draper", phone: "+1 (212) 555-0160", note: "Sterling Cooper Draper Pryce" },
  { id: "darwin", first: "Darwin", last: "Watterson", phone: "+1 (619) 555-0123", note: "Gumball's brother" },
  { id: "arthur", first: "Arthur", last: "Morgan", phone: "+1 (307) 555-0189", note: "Prefers telegrams" },
  { id: "kwame", first: "Kwame From The Gym", phone: "+233 55 555 0142", note: "Leg day is Thursday" },
  { id: "kyle", first: "Kyle", phone: "+1 (206) 555-0104", note: "Season 4 script: in progress" },
  { id: "mom", first: "Mom", phone: "+233 24 555 0110", favourite: "mobile" },
  { id: "peter", first: "Peter", last: "Parker", phone: "+1 (718) 555-0163", note: "Didn't make Phase 4" },
  { id: "recruiter", first: "Recruiter", phone: "+1 (415) 555-0199", note: "Wants to talk about a role" },
  { id: "morty", first: "Morty", last: "Smith", phone: "+1 (505) 555-0135" },
  { id: "rick", first: "Rick", last: "Sanchez", phone: "+1 (505) 555-0137", note: "C-137", favourite: "FaceTime" },
  { id: "tony", first: "Tony", last: "Stark", phone: "+1 (212) 555-0170" },
  { id: "thanos", first: "Thanos", phone: "+1 (310) 555-0114", note: "Same shopping list as me", favourite: "mobile" },
  { id: "bruce", first: "Bruce", last: "Wayne", phone: "+1 (201) 555-0119" },
];

export const fullName = (c) => [c.first, c.last].filter(Boolean).join(" ");
export const sortKey = (c) => (c.last || c.first).toLowerCase();
export const initials = (c) =>
  c.last ? `${c.first[0]}${c.last[0]}`.toUpperCase() : c.first.replace(/[^A-Za-z]/g, "")[0].toUpperCase();

// Contacts in sections by the first letter of the name they sort by: [{ letter, contacts }].
export const sections = (contacts) =>
  [...contacts]
    .sort((a, b) => sortKey(a).localeCompare(sortKey(b)))
    .reduce((acc, c) => {
      const letter = /[a-z]/.test(sortKey(c)[0]) ? sortKey(c)[0].toUpperCase() : "#";
      const last = acc[acc.length - 1];
      if (last && last.letter === letter) last.contacts.push(c);
      else acc.push({ letter, contacts: [c] });
      return acc;
    }, []);

// Recent calls, newest first: who (a contact id, or just a number), the kind of call, its
// direction, and how many minutes ago, so the list always reads as recent.
export const RECENTS = [
  { who: "rick", kind: "FaceTime Video", dir: "out", ago: 34 },
  { who: "thanos", kind: "phone", dir: "in", missed: true, ago: 96 },
  { who: "arthur", kind: "phone", dir: "in", missed: true, count: 3, ago: 140 },
  { who: "mom", kind: "phone", dir: "in", ago: 190 },
  { who: "kyle", kind: "WhatsApp Audio", dir: "out", ago: 305 },
  { who: "recruiter", kind: "phone", dir: "in", missed: true, count: 2, ago: 470 },
  { who: "morty", kind: "Snapchat Audio", dir: "in", ago: 60 * 26 },
  { who: "don", kind: "phone", dir: "in", ago: 60 * 31 },
  { who: "darwin", kind: "FaceTime Video", dir: "out", ago: 60 * 40 },
  { who: "kwame", kind: "WhatsApp Audio", dir: "out", ago: 60 * 50 },
  { number: "+1 (212) 555-0188", kind: "phone", dir: "in", ago: 60 * 75 },
  { who: "area51", kind: "phone", dir: "in", missed: true, ago: 60 * 24 * 4 },
  { who: "tony", kind: "FaceTime Audio", dir: "out", ago: 60 * 24 * 6 },
  { who: "chihiro", kind: "WhatsApp Video", dir: "out", ago: 60 * 24 * 9 },
];
